import styled from 'styled-components'

interface IStyleProps {
  investCard?: boolean
  height?: number
}

export const KanbanColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  gap: 5px;
  margin: 0px;
  padding: 16px 10px;
  border-radius: 5px;
  background-color: #f9f9f9;

  height: ${(props: IStyleProps) => {
    if (props.height) return `${props.height}px`
    return `${window.innerHeight - 205}px`
  }};
  min-width: ${(props: IStyleProps) => {
    if (props.investCard) return '313px'
    return '240px'
  }};

  .column-name {
    display: flex;
    align-items: center;
    align-self: center;
    font-size: 11.5px;
    font-style: normal;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0.01em;
    text-align: left;
    color: #070707;
  }

  .task-list {
    padding-top: 10px;
    ::-webkit-scrollbar {
      width: 8px;
      background-color: none;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track {
      margin-top: 20px;
      background: white;
      border: 0;
    }
    ::-webkit-scrollbar-thumb {
      width: 8px;
      background-color: #c4c4c4;
      border-radius: 50px;
    }
  }

  .kanban-card-container {
    display: flex;
    position: relative;
    justify-content: center;
    padding: 20px 1px 1px 1px;
    /* margin-top: 15px; */
    height: auto;
    max-width: ${(props: IStyleProps) => {
      if (props.investCard) return '330px'
      return '210px'
    }};
    width: 100%;
  }
`

export const KanbanContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0;
  width: 100%;
  gap: 5px;
  overflow-x: scroll;
  max-width: calc(100% - 20px);
  ::-webkit-scrollbar {
    height: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track {
    background: white;
    border: 0;
    margin-top: 8px;
  }
  ::-webkit-scrollbar-thumb {
    height: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  .icon-kanban {
    margin-right: 5px;
    width: 12px;
    height: 12px;
  }
  .column-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }
`
